import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'app-dialog-question-message',
    templateUrl: 'dialog-question-message.component.html',
    styleUrls: ['dialog-question-message.component.scss']
})
export class DialogQuestionMessage implements OnInit {

    title : string;
    body : string;
    bodyIsArray : boolean;
    danger : boolean;
    hideButtons : boolean;
    negativeButton: string;
    positiveButton: string;

    constructor(
        public dialogRef: MatDialogRef<DialogQuestionMessage>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit() {
        this.title = this.data["title"] ? this.data["title"] : "";
        this.body = this.data["body"] ? this.data["body"] : "";
        this.danger = this.data["danger"] ? this.data["danger"] : false;
        this.hideButtons = this.data["hideButtons"] ? this.data["hideButtons"] : false;
        this.negativeButton = this.data["negativeButton"] ? this.data["negativeButton"] : "Fermer";
        this.positiveButton = this.data["positiveButton"] ? this.data["positiveButton"] : "Oui";

        if (Array.isArray(this.body))
            this.bodyIsArray = true;
    }

    dismissDialog() {
        this.dialogRef.close();
    }

    positiveAnswer() {
        this.dialogRef.close({positive : true});
    }
}
